import axios from '@/axios';
import * as types from '../mutation-types';
export default {
	namespaced: true,

	state: {
		quickMessages: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/center/{centerId}/user/{username}/quick-messages').then(({ data }) => {
				commit(types.STORE_QUICK_MESSAGES, data);
				return data;
			});
		},

		create({ commit }, { message }) {
			return axios.post('/center/{centerId}/user/{username}/quick-messages', {
				Message: message
			});
		},

		update({ commit }, { id, message }) {
			return axios.put(`/center/{centerId}/user/{username}/quick-messages/${id}`, {
				Message: message
			});
		},

		delete({ commit }, { id }) {
			return axios.delete(`/center/{centerId}/user/{username}/quick-messages/${id}`);
		},

		reset({ commit }) {
			commit(types.RESET)
		}
	},

	mutations: {
		[types.STORE_QUICK_MESSAGES](state, quickMessages) {
			state.quickMessages = quickMessages;
		},

		[types.RESET](state) {
			state.quickMessages = [];
		}
	},

	getters: {
		getQuickMessageById: state => id => state.quickMessages.find(c => c.ID === id)
	}
}